function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo } from 'react';
import { useStateInRef } from "../../utils/useStateInRef";
import { BiContext, keysToSnakeCase } from "./BiContext";
import { jsx as _jsx } from "react/jsx-runtime";
export function BiProvider(_ref) {
  let {
    children,
    logBi
  } = _ref;
  const getLogBi = useStateInRef(logBi);
  const logBiClick = useCallback(biEvent => {
    var _biEvent$hierarchy;
    getLogBi()(_objectSpread(_objectSpread({}, keysToSnakeCase(biEvent.data)), {}, {
      type: 'click',
      action_type: biEvent.actionType,
      entity_type: biEvent.entityType,
      entity_name: biEvent.entityName,
      hierarchy: (_biEvent$hierarchy = biEvent.hierarchy) !== null && _biEvent$hierarchy !== void 0 ? _biEvent$hierarchy : []
    }));
  }, []);
  const logBiPageView = useCallback(biEvent => {
    getLogBi()(_objectSpread(_objectSpread({}, keysToSnakeCase(biEvent.data)), {}, {
      type: 'page_view',
      page_name: biEvent.pageName,
      hierarchy: [biEvent.pageName]
    }));
  }, []);
  const logBiModalView = useCallback(biEvent => {
    var _biEvent$hierarchy2;
    getLogBi()(_objectSpread(_objectSpread({}, keysToSnakeCase(biEvent.data)), {}, {
      type: 'modal_view',
      entity_type: 'modal',
      entity_name: biEvent.modalName,
      hierarchy: (_biEvent$hierarchy2 = biEvent.hierarchy) !== null && _biEvent$hierarchy2 !== void 0 ? _biEvent$hierarchy2 : []
    }));
  }, []);
  const startTransaction = useCallback(input => {
    var _input$hierarchy;
    const startTime = performance.now();
    getLogBi()(_objectSpread(_objectSpread({}, keysToSnakeCase(input.data)), {}, {
      type: 'transaction',
      transaction_name: input.transactionName,
      status: 'start',
      hierarchy: (_input$hierarchy = input.hierarchy) !== null && _input$hierarchy !== void 0 ? _input$hierarchy : []
    }));
    return endData => {
      var _input$hierarchy2;
      const durationMs = Math.round(performance.now() - startTime);
      getLogBi()(_objectSpread(_objectSpread(_objectSpread({}, keysToSnakeCase(input.data)), keysToSnakeCase(endData)), {}, {
        type: 'transaction',
        transaction_name: input.transactionName,
        status: 'end',
        duration_ms: durationMs,
        hierarchy: (_input$hierarchy2 = input.hierarchy) !== null && _input$hierarchy2 !== void 0 ? _input$hierarchy2 : []
      }));
    };
  }, []);
  const value = useMemo(() => ({
    logBiClick,
    logBiPageView,
    logBiModalView,
    startTransaction
  }), [logBiClick, logBiPageView, logBiModalView, startTransaction]);
  const getValue = useStateInRef(value);
  return /*#__PURE__*/_jsx(BiContext.Provider, {
    value: getValue,
    children: children
  });
}